import React from "react";
import { techStackDetails } from "../Details";

function Technologies() {
  const {
    html,
    css,
    js,
    react,
    tailwind,
    bootstrap,
    jest,
    git,
    postman,
    figma,
    nodejs,
    mongodb,
    docker,
    materialui,
    apigateway,
    lambda,
    dynamodb,
    s3,
    cloudfront,
    cloudwatch,
    sns,
    ses,
    expressjs,
    postgre,
    typescript,
    go,
  } = techStackDetails;

  return (
    <main className="container mx-auto max-width pt-10 pb-20">
      {/* Front-End Technologies */}
      <section>
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Front-End Technologies
        </h1>
        <p className="text-content py-2 lg:max-w-3xl">
          Technologies I've been using for front-end development
        </p>
        <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
          <img
            src={react}
            title="React"
            alt="React"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={typescript}
            title="TypeScript"
            alt="TypeScript"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={js}
            title="JavaScript"
            alt="JavaScript"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={tailwind}
            title="Tailwind CSS"
            alt="Tailwind CSS"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={bootstrap}
            title="Bootstrap"
            alt="Bootstrap"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={jest}
            title="Jest"
            alt="Jest"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={materialui}
            title="Material-UI"
            alt="Material-UI"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
        </section>
      </section>

      {/* Back-End Technologies */}
      <section>
        <h1 className="text-2xl pt-10 text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Back-End Technologies
        </h1>
        <p className="text-content py-2 lg:max-w-3xl">
          Technologies I've been using for back-end development
        </p>
        <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
          <img
            src={go}
            title="Go"
            alt="Go"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={postgre}
            title="PostgreSQL"
            alt="PostgreSQL"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={nodejs}
            title="Node.js"
            alt="Node.js"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={expressjs}
            title="Express JS"
            alt="Express JS"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={mongodb}
            title="MongoDB"
            alt="MongoDB"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={docker}
            title="Docker"
            alt="Docker"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
        </section>
      </section>

      {/* Cloud Computing */}
      <section>
        <h1 className="text-2xl pt-10 text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Cloud Computing
        </h1>
        <p className="text-content py-2 lg:max-w-3xl">
          Cloud services I've been using recently
        </p>
        <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
          <img
            src={lambda}
            title="AWS Lambda"
            alt="AWS Lambda"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={apigateway}
            title="API Gateway"
            alt="API Gateway"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={dynamodb}
            title="DynamoDB"
            alt="DynamoDB"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={s3}
            title="Amazon S3"
            alt="Amazon S3"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={cloudfront}
            title="CloudFront"
            alt="CloudFront"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={cloudwatch}
            title="CloudWatch"
            alt="CloudWatch"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={sns}
            title="Amazon Simple Notification Service"
            alt="SNS"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={ses}
            title="Amazon Simple Email Service"
            alt="SES"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
        </section>
      </section>

      {/* Development Tools */}
      <section>
        <h1 className="text-2xl pt-10 text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Development Tools
        </h1>
        <p className="text-content py-2 lg:max-w-3xl">
          Tools I've been using for development and collaboration
        </p>
        <section className="grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 items-center gap-10 pt-6">
          <img
            src={git}
            title="Git"
            alt="Git"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={postman}
            title="Postman"
            alt="Postman"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
          <img
            src={figma}
            title="Figma"
            alt="Figma"
            className="transform hover:scale-110 hover:shadow-lg transition duration-300 ease-in-out"
          />
        </section>
      </section>
    </main>
  );
}

export default Technologies;
